import post from './post'
import pre from './pre'
import Config from './config/index.vue'
import Cart from './cart.vue'

export default {
  pre,
  post,
  components: {
    config: Config,
    cart: Cart,
  },
}
